import { atom } from 'jotai'

export const userInfoAtom = atom(null);
export const rememberUser = atom(false);